/**
 * Temporary company source badge/color config for AllocationBreakdown.
 *
 * TODO: Remove this file and import from `shared/companySource/companySourceConfig`
 * once `feature/po-line-item-procured-for-partner` is merged.
 * That shared config does not exist on main yet.
 */

const COMPANY_SOURCE_BADGE_COLORS = {
    misfits_market: '#F1C34A',
    blue_apron: '#7dA0FF',
    marley_spoon: '#B774F2',
};

const COMPANY_SOURCE_PALE_BACKGROUNDS = {
    misfits_market: '#FDF6E3',
    blue_apron: '#EEF2FF',
    marley_spoon: '#F3E8FF',
};

const COMPANY_SOURCE_BADGE_LABELS = {
    misfits_market: '1P',
    blue_apron: 'BA',
    marley_spoon: 'MS',
};

const NEUTRAL_SOURCE_CODE = 'misfits_market';

/**
 * @param {string} code
 * @returns {string | null}
 */
function getCompanySourceBadgeLabel(code) {
    return COMPANY_SOURCE_BADGE_LABELS[code] ?? null;
}

/**
 * @param {string} code
 * @returns {{ badgeColor: string, backgroundColor: string, borderColor: string }}
 */
function getCompanySourceColors(code) {
    const resolvedCode = COMPANY_SOURCE_BADGE_COLORS[code] ? code : NEUTRAL_SOURCE_CODE;
    const badgeColor = COMPANY_SOURCE_BADGE_COLORS[resolvedCode];
    const backgroundColor = COMPANY_SOURCE_PALE_BACKGROUNDS[resolvedCode];

    return {
        badgeColor,
        backgroundColor,
        borderColor: badgeColor,
    };
}

export {
    COMPANY_SOURCE_BADGE_COLORS,
    COMPANY_SOURCE_BADGE_LABELS,
    COMPANY_SOURCE_PALE_BACKGROUNDS,
    getCompanySourceBadgeLabel,
    getCompanySourceColors,
};
